import React, { useState } from 'react';
import { Button, Tooltip, CircularProgress, Box } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import RefreshIcon from '@mui/icons-material/Refresh';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import BoltIcon from '@mui/icons-material/Bolt';
import { chayNutChucNang } from './nutChucNangDanhSach';

/**
 * NÚT CHỨC NĂNG RIÊNG của danh sách — vẽ trên thanh tiêu đề, cạnh các nút chung (in, xoá, sắp xếp).
 *
 * Mỗi nút một trạng thái "đang chạy" riêng, và CHỈ một nút chạy tại một thời điểm: đồng bộ với
 * Facebook mất vài giây; người dùng không thấy phản hồi sẽ bấm lại, và hai lượt đồng bộ chồng nhau
 * thì ghi đè số liệu của nhau.
 */
const BIEU_TUONG = {
  sync: SyncIcon, refresh: RefreshIcon, download: FileDownloadOutlinedIcon, upload: FileUploadOutlinedIcon,
  send: SendOutlinedIcon, play: PlayArrowIcon, bolt: BoltIcon,
};

/**
 * Thanh tiêu đề (DataListHeader) ép MỌI nút về ô vuông 44px: `'& .MuiButton-root': { width: 44, padding: 0 }`.
 * Nút chức năng riêng có CHỮ nên bị bóp lại và chữ tràn đè lên các nút bên cạnh. Quy tắc của thanh tiêu đề
 * có độ ưu tiên 2 class (`.cha .MuiButton-root`) — ngang với `sx` của nút, bên nào nạp sau thắng, tức là
 * hên xui. `&&&` nâng lên 3 class để chắc chắn thắng. Màn hình hẹp chỉ còn biểu tượng -> vẫn đủ 44px.
 */
const NUT_SX = {
  '&&&': { width: 'auto', minWidth: 44, px: 1.25, gap: 0.75, whiteSpace: 'nowrap', flexShrink: 0 },
};

export default function DataListActions({ actions, layThamSo, context, onXong }) {
  const [dangChay, setDangChay] = useState('');
  if (!Array.isArray(actions) || !actions.length) return null;

  const bao = (msg, mau) => { if (msg && context && context.alert) context.alert(msg, null, mau); };

  const bam = (nut, khoa) => {
    if (dangChay) return;
    const chay = async () => {
      setDangChay(khoa);
      try {
        // Lấy tham số NGAY LÚC BẤM, không phải lúc vẽ: điều kiện lọc và các dòng đang chọn có thể đã
        // đổi từ lần vẽ trước.
        const kq = await chayNutChucNang(nut, layThamSo ? layThamSo() : {});
        bao(kq.message, kq.color);
        if (kq.refresh && onXong) onXong();
      } finally {
        setDangChay('');
      }
    };
    if (nut.confirm && context && context.alert) context.alert(nut.confirm, (yes) => { if (yes) chay(); });
    else chay();
  };

  return (
    <React.Fragment>
      {actions.map((nut, i) => {
        if (!nut) return null;
        const khoa = nut.code || String(i);
        const Icon = BIEU_TUONG[String(nut.icon || '').toLowerCase()] || null;
        const dang = dangChay === khoa;
        return (
          <Tooltip key={khoa} title={nut.tooltip || nut.label || ''} placement="bottom">
            <span style={{ display: 'inline-flex' }}>
              <Button variant={nut.variant || 'outlined'} onClick={() => bam(nut, khoa)} disabled={!!dangChay}
                sx={NUT_SX}>
                {dang ? <CircularProgress size={16} color="inherit" /> : (Icon ? <Icon fontSize="small" /> : null)}
                {/* Có biểu tượng thì màn hình hẹp chỉ hiện biểu tượng (tên nằm ở tooltip); không có thì
                    luôn hiện tên — một nút trống trơn thì không ai dám bấm. */}
                {/*<Box component="span" sx={Icon ? { display: { xs: 'none', md: 'inline' } } : undefined}>
                  {dang ? 'Đang chạy…' : nut.label}
                </Box>*/}
              </Button>
            </span>
          </Tooltip>
        );
      })}
    </React.Fragment>
  );
}
